// @flow

import * as React from 'react';
import { connect } from 'react-redux';
import { Transition } from 'react-transition-group';
import { Transition as OverlayTransition } from '@ta/overlays.pieces';
import Logging from '@ta/common.logging';

type ExternalProps = {|
  /** The name of the contained overlay */
  name: string,

  /** The contents of the overlay */
  children: React.Node,

  /** Length of the transitions for entering and exiting. This should be in sync with an overlay's animation transition timing. */
  transitionDuration?: number,
|};

type Props = {|
  ...ExternalProps,

  /** Show the component */
  show?: boolean,
|};

const nameUsage = new Map();

/**
 * Local is used to define a "local" overlay--that is, one that can co-exist with other overlays on the same page,
 * even sitting on to of a modal, for example. They should be small (Like tooltips, or popovers).
 */
class Local extends React.Component<Props> {
  componentDidMount() {
    const { name } = this.props;
    if (!nameUsage.has(name)) {
      nameUsage.set(name, 1);
    } else {
      const foundTimes = nameUsage.get(name) + 1;
      nameUsage.set(name, foundTimes);
      Logging.error(
        `Local overlay with name: ${name} found ${foundTimes} times, please use another alias`,
      );
    }
  }

  componentWillUnmount() {
    const { name } = this.props;
    nameUsage.delete(name);
  }

  render() {
    const { show, children, transitionDuration } = this.props;

    return (
      <Transition in={show} timeout={transitionDuration || 0} mountOnEnter unmountOnExit>
        {status => (
          <OverlayTransition.Provider value={status}>{children}</OverlayTransition.Provider>
        )}
      </Transition>
    );
  }
}

export default connect<Props, ExternalProps, _, _, _, _>((state, { name }: ExternalProps) => ({
  show: !!state.overlays.locals[name],
}))(Local);
